// Fire-and-forget POST an externen Worker — nur für Kühlfahrzeug-Anfragen.
// Fehler werden geschluckt (console.warn), damit die UX nicht leidet.

const ENDPOINT = "https://frostflotte.intern-app.workers.dev/api/inquiry";
const KEY = "ff_web_a7Qm2vXp9KdR";

const NON_COOLING_PATHS = ["/transporter-mieten", "/kleinbus-mieten-frankfurt"];

export function isCoolingInquiry(pathname: string | undefined | null): boolean {
  if (!pathname) return true;
  return !NON_COOLING_PATHS.some((p) => pathname.startsWith(p));
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === "") return undefined;
  if (typeof value === "number") return Number.isFinite(value) ? value : undefined;
  const cleaned = String(value)
    .replace(/€|km|\s/gi, "")
    .replace(/\./g, "")
    .replace(/,/g, ".");
  const n = Number.parseFloat(cleaned);
  return Number.isFinite(n) ? n : undefined;
}

function toDateString(value: unknown): string | undefined {
  if (!value) return undefined;
  if (value instanceof Date) {
    const p = (n: number) => String(n).padStart(2, "0");
    return value.getFullYear() + "-" + p(value.getMonth() + 1) + "-" + p(value.getDate());
  }
  if (typeof value === "string") {
    // Accept either "YYYY-MM-DD" oder ISO
    return value.length >= 10 ? value.slice(0, 10) : value;
  }
  return undefined;
}

export interface ExternalInquiryPayload {
  name?: string;
  email?: string;
  phone?: string;
  firma?: string;
  vehicle?: string;
  start?: string | Date | null;
  end?: string | Date | null;
  price?: number | string | null;
  includedKm?: number | string | null;
  extraKm?: number | string | null;
  anlieferung?: boolean;
  anlieferungText?: string;
  temperatur?: string;
  message?: string;
}

export function notifyExternalInquiry(payload: ExternalInquiryPayload): void {
  try {
    const body: Record<string, unknown> = { key: KEY };
    if (payload.name) body.name = payload.name;
    if (payload.email) body.email = payload.email;
    if (payload.phone) body.phone = payload.phone;
    if (payload.firma) body.firma = payload.firma;
    if (payload.vehicle) body.vehicle = payload.vehicle;
    const start = toDateString(payload.start);
    if (start) body.start = start;
    const end = toDateString(payload.end);
    if (end) body.end = end;
    const price = toNumber(payload.price);
    if (price !== undefined) body.price = price;
    const includedKm = toNumber(payload.includedKm);
    if (includedKm !== undefined) body.includedKm = includedKm;
    const extraKm = toNumber(payload.extraKm);
    if (extraKm !== undefined) body.extraKm = extraKm;
    if (typeof payload.anlieferung === "boolean") body.anlieferung = payload.anlieferung;
    if (payload.anlieferungText) body.anlieferungText = payload.anlieferungText;
    if (payload.temperatur) body.temperatur = payload.temperatur;
    if (payload.message) body.message = payload.message;

    fetch(ENDPOINT, {
      method: "POST",
      mode: "no-cors",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).catch((err) => {
      console.warn("[notifyExternalInquiry] request failed:", err);
    });
  } catch (err) {
    console.warn("[notifyExternalInquiry] build failed:", err);
  }
}

